<template>
    <div id="coin-menu" class="game" :data-coin="coin_type">
        <router-link to="/" tag="div" class="close">×</router-link>
        <h1>Choose coin</h1>
        <div class="game-wrapper layout-1">
            <ul id="coin-menu-list">
                <router-link v-for="(coin_info, coin_type) of coins" :to="`/game/coin/${coin_type}`" tag="li" v-bind:key="coin_type">
                    <div><img :src="coin_info.top" alt="" /></div>
                    <h5>{{ coin_info.name }}</h5>
                </router-link>
            </ul>
        </div>
    </div>
</template>

<script>
  import COINS from './../coins.json'

  export default {
    data: function () {
      return {
        'coins': COINS,
      }
    }
  }
</script>

<style src="./../assets/css/game.css" scoped></style>
<style scoped>

    #coin-menu {
        background: #d59a5c url('../assets/img/game/coin/bg.jpg');
        background-size: cover;
        overflow: hidden;
        text-align: center;
    }

    #coin-menu-list {
        margin: 2rem;
    }

    #coin-menu-list li {
        max-width: 320px;
        width: 25%;
        padding-left: 1rem;
        padding-right: 1rem;
        padding-bottom: 2rem;
        box-sizing: border-box;
        text-align: center;
        color: #ffffff;
        cursor: pointer;
        display: inline-block;
        vertical-align: top;
    }

    #coin-menu-list li img {
        border-radius: 256px;
        width: 100%;
    }

    #coin-menu-list li h5 {
        margin-top: 0.5rem;
        font-weight: bold;
    }

    @media all and (max-width: 960px) {

        #coin-menu-list li {
            width: 50%;
        }

        #coin-menu-list li h5 {
            font-size: 0.8rem;
        }

    }

    @media all and (max-width: 639px) {


    }

    @media all and (max-width: 480px) {


    }

</style>
